import Abstract from "../../../abstract-view/abstract.js";

import {
  debounce
} from "../../../../utils/debounce.js";

import {
  DEBOUNCE_INPUT_TIME
} from "../../const.js";
export default class Input extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._inputHandler = this._inputHandler.bind(this);
    this._focusHandler = this._focusHandler.bind(this);
    this._blurHandler = this._blurHandler.bind(this);
  }

  getMin() {
    return +this._element.dataset.min;
  }

  getMax() {
    return +this._element.dataset.max;
  }

  getValue() {
    return +this._element.value;
  }

  getName() {
    return this._element.name;
  }

  setValue(value) {
    this._element.value = value;
  }

  getDefault() {
    return +this._element.dataset.default;
  }

  getPlaceholder() {
    return +this._element.placeholder;
  }

  setPlaceholder(value) {
    this._element.placeholder = value;
  }

  setInputHandler(callback) {
    this._callback.change = callback;
    this._element.addEventListener(`input`, debounce(this._inputHandler, DEBOUNCE_INPUT_TIME));
  }

  setFocusHandler(callback) {
    this._callback.focus = callback;
    this._element.addEventListener(`focus`, this._focusHandler);
  }

  setBlurHandler(callback) {
    this._callback.blur = callback;
    this._element.addEventListener(`blur`, this._blurHandler);
  }

  _inputHandler() {
    this._callback.change();
  }

  _focusHandler() {
    this._callback.focus();
  }

  _blurHandler() {
    this._callback.blur();
  }
}
